module.exports = __webpack_public_path__ + "img/img_9.c2754c70.png";